export enum AgprComponentStyleEnum {
    // used in AT, AM
    default = 'DEFAULT',
    // used in social for tools within a containers
    social = 'SOCIAL',
    // used in social for tools at the top of the page, which are higher and use $radius-md
    socialPlus = 'SOCIAL_PLUS'
}
